import {Vue, Component} from 'vue-property-decorator'


import '../style/EquipmentList.less'
import Navigation from "@/components/Navigation";
import {Observer} from 'mobx-vue'
import EquipmentListStore from '../store/EquipmentListStore'

@Observer
@Component
class EquipmentList extends Vue {
    state = {
        EquipmentListStore
    }

    created() {
        this.state.EquipmentListStore.getAppList()
    }

    render() {
        const {list, maxMonitorCount} = this.state.EquipmentListStore
        return (
            <div class='z_equipmentList'>
                <Navigation title="应用监控"/>
                {
                    list.length ? (
                            <div>
                                <div class='prompt'>单个云手机最多只能监控{maxMonitorCount}款应用</div>

                                <div class='list'>
                                    {list.map((items: any) =>
                                        <router-link
                                            to={`/applicationList?cid=${items.cid}&maxMonitorCount=${maxMonitorCount}&&deviceName=${items.deviceName}`}>

                                            <div class='equipment'>
                                                <div class='name ellipsis'>{items.deviceName}</div>
                                                <div class='num'>已监控{items.monitorAppsCount}款应用</div>

                                                <div class='logo' hidden={items.appList ? false : true}>
                                                    {
                                                        items.appList && items.appList.slice(0,2).map((item: any) =>
                                                            <img src={item.appIcon}/>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </router-link>
                                    )}
                                </div>
                            </div>
                        )
                        : (
                            <div class='noEquipment'>
                                <img src={require('../assets/img/equipment.png')}/>
                                <p>您尚未购买云手机</p>
                            </div>
                        )
                }


            </div>
        )
    }
}

export default EquipmentList


